/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<f766f0e272ff10634ee82eab7662e0ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConversationUser$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConversationInputUser" | "conversationMessageListUser">;
  readonly " $fragmentType": "ConversationUser";
};
export type ConversationUser$key = {
  readonly " $data"?: ConversationUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConversationUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationUser",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "conversationMessageListUser"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationInputUser"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "a85388e1500f65b0e8e8844679a15601";

export default node;
